export default "__VITE_ASSET__CTarpuB7__"